<template>
  <div class="navget_main">
    <img
      :src="
        goImg
          ? themeStyleVs === 2
            ? blockClose
            : closeImg
          : themeStyleVs === 2
          ? blockBackImg
          : backImg
      "
      @click.stop="goBack()"
    ></img>
    <div class="center-content">
      <span>{{ text }}</span>
      <span v-if="isMock" class="mock-tag">模拟</span>
    </div>

    <div class="right-icon">
      <img
        v-if="shareImgShow && compareVersions(version, 9.68)"
        class="share_btn_box"
        :src="themeStyleVs === 2 ? blackShare : shareBtn"
        @click="shareFn"
        alt=""
      />
      <img
        v-if="reloadImgShow"
        class="share_btn_box"
        :src="themeStyleVs === 2 ? reloadBtnBlock : reloadBtn"
        @click="reloadFn"
        alt=""
      />
    </div>
  </div>
</template>
<script>
import { compareVersions } from '@/utils/format';
import mixins from '@/mixins/index.js';
export default {
  name: 'navigation',
  mixins: [mixins],
  props: {
    text: {
      type: String,
      required: true
    },
    searchShow: {
      type: Boolean,
      required: true
    },
    shareImgShow: {
      default: false
    },
    reloadImgShow: {
      default: false
    },
    isMock: {
      default: false
    },
    mark: {
      default: ''
    }
  },
  data() {
    return {
      backImg: require('../assets/image/left.png'),
      blockBackImg: require('../assets/image/blockImg/left.png'),
      searchImg: require('../assets/image/search.png'),
      closeImg: require('../assets/image/close_btn.png'),
      blockClose: require('../assets/image/blockImg/close.png'),

      shareBtn: require('../assets/image/share_btn.png'),
      blackShare: require('../assets/image/blockImg/share_img.png'),

      reloadBtn: require('../assets/image/reload.png'),
      reloadBtnBlock: require('../assets/image/reload_block.png'),

      sourceType: 'false',
      goImg: false,
      themeStyleVs: 1,
      shareType: 'false',
      version: 0,
      source: ''
    };
  },
  filters: {},
  created() {
    this.themeStyleVs = Number(this.getUrlQuery('themeStyleVs'));
    this.shareType = this.getUrlQuery('shareType');
    this.version = this.getUrlQuery('version');
    this.source = this.getUrlQuery('source');
  },
  mounted() {
    this.goImg = this.$route.name === 'My' || this.shareType == 'true' ? true : false;
    this.sourceType = this.getUrlQuery('sourceType') ? this.getUrlQuery('sourceType') : 'false';




    //  console.log('this.shareType',this.shareType);
    //   console.log('this.shareType',typeof this.shareType);
    //   console.log('this.sourceType',this.sourceType);
    //   console.log('this.sourceType',typeof this.sourceType);

    //   console.log('this.source',this.source);
    //   console.log('this.source',typeof this.source);

  },
  methods: {
    compareVersions,
    goBack: function () {
      if (this.mark == 'clgc') {
        location.href = 'dzh_browser_url&goto=0&screen=263';
        return false;
      }

      if (this.source == 'appLhHc') {
        this.$router.go(-1);
        return false;
      }
      if (this.shareType == 'true') {
        location.href = 'dzh_browser_url&goto=0&screen=263';
      } else {
        if (this.sourceType === 'true') {
          this.$router.go(-1);
        } else {
          if (typeof DzhAppJs == 'undefined') {
            window.close();
          } else {
            location.href = 'dzh_browser_url&goto=0&screen=263';
          }
        }
      }
    },
    shareFn: function () {
      this.$emit('shareBtn');
    },
    // 刷新
    reloadFn: function () {
      // 刷新页面
      location.href = 'dzh_browser_url&goto=0&screen=188';
    }
  }
};
</script>
<style lang="less" scoped>
.navget_main {
  //   width: 100%;
  height: 44px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  font-weight: bold;
  font-size: 16px;
  .right-icon {
    width: 24px;
    height: 24px;
  }
  img {
    width: 24px;
    height: 24px;
  }

  .center-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
  }

  .mock-tag {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.8);
    border-radius: 2px;
    background: linear-gradient(0deg, #5585e4, #5585e4), rgba(255, 255, 255, 0.76);
    padding: 0px 3px;
    margin-top: 2px;
  }
}
</style>
